import React from "react";
import { styled } from '@mui/material/styles';

import { GatsbyImage } from "gatsby-plugin-image";
import { Link } from "gatsby"
import { getEntityUrl } from "../../util";
import {EntityListItems} from "../../components/List";
import WmaInlineListItemLayout from "../wma-list/list";

const PREFIX = 'List';

const classes = {
    listItem: `${PREFIX}-listItem`,
    listLink: `${PREFIX}-listLink`,
    listImg: `${PREFIX}-listImg`,
    titleDiv: `${PREFIX}-titleDiv`,
    titleFlex: `${PREFIX}-titleFlex`,
    title1: `${PREFIX}-title1`,
    title2: `${PREFIX}-title2`,
    title3: `${PREFIX}-title3`,
    numCode: `${PREFIX}-numCode`,
    playButton: `${PREFIX}-playButton`
};

const Root = styled('ul')((
    {
        theme
    }
) => ({
    [`& .${classes.listItem}`]: {
        textDecoration: 'none',
        cursor: 'pointer',
        background: '#efefef',
        padding: '0',
         /* STANDART margin: '0px 0px 6px 0px',*/
        listStyle: 'none',
        display: 'flex',
        justifyContent: 'flex-start',
        minHeight: '48px',
        /* CUSTOM 1*/
        margin: '5px 6px 5px 6px',
        overflow: 'hidden',
        alignItems: 'center',
        borderRadius: '10px',
        boxShadow: '0 5px 7px -1px rgba(51, 51, 60, 0.4)',
        rowGap: '8px',

    },

    [`& .${classes.listLink}`]: {
        textDecoration: 'none',
        color: '#000',

    },

    /* STANDART
    listImg: {
        maxWidth: '110px',
        display: 'flex',

    },*/

    /* CUSTOM 1 */

    [`& .${classes.listImg}`]: {
        width: '110px',
        minWidth: '110px',
        height: '80px',
        borderRadius: '50%',
        boxShadow: '0 0 0 7px #b7b7b7, 0 0 0 21px #C9C9C9, 0 0 0 63px #D3D3D3, 0 0 0 186px #E1E1E1, 0 0 0 558px #e7e7e7',
        display: 'flex',
     },

    /* End CUSTOM 1*/

    [`& .${classes.titleDiv}`]: {
        minWidth: '0',
        overflow: 'hidden',
        padding: '10px 28px 10px 8px'
    },

    [`& .${classes.titleFlex}`]: {

        display: 'flex',
        flexGrow: '1',

        alignItems: 'center',
        position: 'relative',
        minHeight: '80px',
    },

    [`& .${classes.title1}`]: {
        fontSize: '15px',
        textTransform: 'uppercase',
        marginBottom: '0',
        paddingRight: '25px',
        lineHeight: '1.15',
        fontWeight: 'bold',
    },

    [`& .${classes.title2}`]: {
        fontSize: '14px',
        lineHeight: '1.2',
        marginTop: '3px',
        paddingRight: '20px',
    },

    [`& .${classes.title3}`]: {
        fontSize: '14px',
        marginBottom: '0px',
        marginTop: '2px',
        fontWeight: 'normal',
    },

    [`& .${classes.numCode}`]: {
        position: 'absolute',
        right: '10px',
        bottom: '7px',
        fontSize: '13px',
        fontWeight: 'bold'
    },

    [`& .${classes.playButton}`]: {
        position: 'absolute',
        right: '6px',
        top: '50%',
        transform: 'translateY(-50%)',
    }
}));

const ListItemLayout = ({ entity, title1, title2, title3, numCode, pageContext, sublistRole, image, associatedEntity, oaiRole }) => {
    const { defaultLocale } = pageContext;
    const sublistStyles = sublistRole && {
        ...(sublistRole?.backgroundColor ? {backgroundColor: sublistRole.backgroundColor + 'ac'} : {}),
    }

    return (
        <Link key={entity.identifier} to={getEntityUrl({ entity, defaultLocale })} className={classes.listLink + " list-item" + (sublistRole ? " inlinelist-item" : "")}>
            <li key={entity.identifier} className={classes.listItem} style={sublistStyles}>
                {image && <GatsbyImage className={classes.listImg} image={image} alt={title1} layout="fullWidth" />}
                <div className={classes.titleFlex}>
                    <div className={classes.titleDiv}>
                        <div className={classes.title1}>{title1}</div>
                        <div className={classes.title2}>{title2}</div>
                        <div className={classes.title3}>{title3}</div>
                        <div className={classes.numCode}>{numCode}</div>
                        <div className={classes.playButton}>
                            <img src={`/images/bigarrow.png`} alt="play" />
                        </div>
                    </div>
                </div>
            </li>
        </Link>
    );
}

const List = ({ entity, pageContext }) => {
    return (
        <Root>
            <EntityListItems entity={entity} pageContext={pageContext} listItemLayout={ListItemLayout} inlineListHeadlineLayout={WmaInlineListItemLayout} />
        </Root>
    );
};

export default List;
